<template>
    <section class="QuestionQuote ContentSection ContentSection--hasclippath">
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="104.4" height="104.4" viewBox="0 0 104.4 104.4">
                <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle"
                    d="M104.963,52.429a52.2,52.2,0,1,1-52.2-52.2A52.2,52.2,0,0,1,104.963,52.429Zm-50.4-34.2c-11.471,0-19.455,4.012-25.2,12.6-.744,1.113-1.067,2.791,0,3.6l9,5.4c1.1.831.949,1.08,1.8,0,3.76-4.769,6.877-7.2,12.6-7.2,4.3,0,10.8,3.03,10.8,7.2,0,3.152-2.954,4.82-7.2,7.2-4.951,2.776-12.6,5.758-12.6,14.4h0c0,1.395,2.205,3.6,3.6,3.6h10.8c1.395,0,3.6-2.205,3.6-3.6h0c0-5.991,16.2-5.389,16.2-21.6C77.963,27.621,66.427,18.229,54.562,18.229Zm-1.8,52.2a8.568,8.568,0,0,0-9,9c0,5.339,3.661,10.8,9,10.8s9-5.461,9-10.8A8.568,8.568,0,0,0,52.762,70.429Z"
                    transform="translate(-0.563 -0.229)" :fill="pageData.color" />
            </svg>
        </div>
        <h3 v-html="properties.quote"></h3>
    </section>
</template>
<script>
export default {
    props: ["properties", "pageData"]
}
</script>
<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';

.QuestionQuote {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 60px;
    padding-bottom: 40px;
    background: #fff;

    &>div {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        width: 100%;
        max-width: var(--content-max-width);
        padding: var(--content-padding);
        margin-bottom: 20px;
    }

    h3 {
        text-align: left;
    }

    @include tablet-down {
        &>div>svg{ 
            width: 80px;
        }
    }
}
</style>